import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    templateUrl: './confirm-message.component.html',
    styleUrls: ['./confirm-message.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, AsyncPipe]
})
export class ConfirmMessageComponent {
  isConfirmed: boolean = false;
  isCancelClicked: boolean = false;
  constructor(
    private matSnackBarRef: MatSnackBarRef<ConfirmMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      message: Observable<string>,
      primaryButtonLabel: Observable<string>,
      secondaryButtonLabel: Observable<string>
    }) {
  }

  protected ok(): void {
    this.isConfirmed = true;
    this.dismiss();
  }

  protected cancel(): void {
    this.isConfirmed = false;
    this.isCancelClicked = true;
    this.dismiss();
  }

  private dismiss(): void {
    this.matSnackBarRef.dismiss();
  }
}
